// extracted by mini-css-extract-plugin
export default {"header":"contentheader_header__bsK1l","menuTablet":"contentheader_menuTablet__soXJh"};